/*
 * @Description: 云途销售管理路由模块
 * @Author: mdb
 * @Date: 2022-05-31 17:39:17
 * @LastEditTime: 2023-06-30 17:26:57
 * @LastEditors: cxh
 */
import Layout from '@/layout/index.vue'

const routerItem = {
  path: '/lbu',
  component: Layout,
  children: [
    {
      path: 'index',
      name: 'DcCosLbuIndex',
      meta: {
        title: '首页',
        noCache: true
      },
      component: require('@/views/yuntuSales/index/index.vue').default
    },
    {
      path: 'salesClue',
      name: 'DcCosLbuSalesClue',
      meta: { title: '销售线索' },
      component: require('@/views/yuntuSales/clueManage/salesClue/index.vue').default
    },
    {
      path: 'salesClue/view',
      name: 'DcCosLbuSalesClueView',
      meta: {
        title: '销售线索详情',
        noCache: true
      },
      component: require('@/views/yuntuSales/clueManage/salesClue/view.vue').default
    },
    {
      path: 'salesClue/add',
      name: 'DcCosLbuSalesClueAdd',
      meta: { title: '新增销售线索' },
      component: require('@/views/yuntuSales/clueManage/salesClue/add.vue').default
    },
    {
      path: 'salesClue/edit',
      name: 'DcCosLbuSalesClueEdit',
      meta: { title: '编辑销售线索' },
      component: require('@/views/yuntuSales/clueManage/salesClue/edit.vue').default
    },
    {
      path: 'salesClue/potential',
      name: 'DcCosLbuSalesCluePotential',
      meta: { title: '转为潜在客户' },
      component: require('@/views/yuntuSales/clueManage/salesClue/potential.vue').default
    },
    {
      path: 'publicClue',
      name: 'DcCosLbuPublicClue',
      meta: { title: '线索公海池' },
      component: require('@/views/yuntuSales/clueManage/publicClue/index.vue').default
    },
    {
      path: 'publicClue/view',
      name: 'DcCosLbuPublicClueView',
      meta: {
        title: '公海池详情',
        noCache: true
      },
      component: require('@/views/yuntuSales/clueManage/salesClue/view.vue').default
    },
    {
      path: 'potential',
      name: 'DcCosLbuPotential',
      meta: { title: '潜在客户' },
      component: require('@/views/yuntuSales/customerCenter/potential/index.vue').default
    },
    {
      path: 'potential/view',
      name: 'DcCosLbuPotentialView',
      meta: {
        title: '潜在客户详情',
        noCache: true
      },
      component: require('@/views/yuntuSales/customerCenter/potential/view/index.vue').default
    },
    {
      path: 'potential/add',
      name: 'DcCosLbuPotentialAdd',
      meta: { title: '潜在客户新增' },
      component: require('@/views/yuntuSales/customerCenter/potential/add/index.vue').default
    },
    {
      path: 'potential/edit',
      name: 'DcCosLbuPotentialPerEdit',
      meta: { title: '潜在客户编辑' },
      component: require('@/views/yuntuSales/customerCenter/potential/edit/index.vue').default
    },
    {
      path: 'turnToDeal',
      name: 'DcCosLbuTurnToDeal',
      meta: { title: '转成交' },
      component: require('@/views/yuntuSales/customerCenter/turnToDeal/index.vue').default
    },
    {
      path: 'clients',
      name: 'DcCosLbuClients',
      meta: { title: '成交客户' },
      component: require('@/views/yuntuSales/customerCenter/clients/index.vue').default
    },
    {
      path: 'clients/view',
      name: 'DcCosLbuClientsView',
      meta: {
        title: '成交客户详情',
        noCache: true
      },
      component: require('@/views/yuntuSales/customerCenter/clients/view/index.vue').default
    },
    {
      path: 'clients/edit',
      name: 'DcCosLbuClientsEdit',
      meta: { title: '成交客户编辑' },
      component: require('@/views/yuntuSales/customerCenter/clients/edit/index.vue').default
    },
    {
      path: 'business',
      name: 'DcCosLbuBusiness',
      meta: { title: '商机管理' },
      component: require('@/views/yuntuSales/chanceManage/business/index.vue').default
    },
    {
      path: 'business/add',
      name: 'DcCosLbuBusinessAdd',
      meta: { title: '新增商机' },
      component: require('@/views/yuntuSales/chanceManage/business/add.vue').default
    },
    {
      path: 'business/view',
      name: 'DcCosLbuBusinessView',
      meta: {
        title: '商机详情',
        noCache: true
      },
      component: require('@/views/yuntuSales/chanceManage/business/view.vue').default
    },
    {
      path: 'business/edit',
      name: 'DcCosLbuBusinessEdit',
      meta: { title: '编辑商机' },
      component: require('@/views/yuntuSales/chanceManage/business/edit.vue').default
    },
    {
      path: 'visitorProgram',
      name: 'DcCosLbuVisitorProgram',
      meta: { title: '访客计划' },
      component: require('@/views/yuntuSales/followUpManage/visitorProgram/index.vue').default
    },
    {
      path: 'visitorProgram/view',
      name: 'DcCosLbuVisitorProgramView',
      meta: {
        title: '访客计划详情',
        noCache: true
      },
      component: require('@/views/yuntuSales/followUpManage/visitorProgram/view.vue').default
    },
    {
      path: 'visitorProgram/add',
      name: 'DcCosLbuVisitorProgramAdd',
      meta: { title: '新增访客计划' },
      component: require('@/views/yuntuSales/followUpManage/visitorProgram/add.vue').default
    },
    {
      path: 'followUpRecord',
      name: 'DcCosLbuFollowUpRecord',
      meta: { title: '跟进记录' },
      component: require('@/views/yuntuSales/followUpManage/followUpRecord/index.vue').default
    },
    {
      path: 'followUpRecord/add',
      name: 'DcCosLbuFollowUpRecordAdd',
      meta: { title: '跟进记录新增' },
      component: require('@/views/yuntuSales/followUpManage/followUpRecord/add/index.vue').default
    },
    {
      path: 'followUpRecord/edit',
      name: 'DcCosLbuFollowUpRecordEdit',
      meta: { title: '跟进记录编辑' },
      component: require('@/views/yuntuSales/followUpManage/followUpRecord/edit/index.vue').default
    },
    {
      path: 'followUpRecord/visitingPlan',
      name: 'DcCosLbuFollowUpRecordVisitingPlan',
      meta: { title: '完成拜访' },
      component: require('@/views/yuntuSales/followUpManage/followUpRecord/followVisitingPlan/index.vue').default
    },
    {
      path: 'followUpRecord/view',
      name: 'DcCosLbuFollowUpRecordView',
      meta: {
        title: '跟进记录详情',
        noCache: true
      },
      component: require('@/views/yuntuSales/followUpManage/followUpRecord/view/index.vue').default
    },
    {
      path: 'followUpRecord/commit',
      name: 'DcCosLbuFollowUpRecordCommit',
      meta: { title: '跟进记录评论' },
      component: require('@/views/yuntuSales/followUpManage/followUpRecord/commit/index.vue').default
    },
    {
      path: 'followRuleSetting',
      name: 'DcCosLbuFollowRuleSetting',
      meta: { title: '跟进规则设置' },
      component: require('@/views/yuntuSales/followRuleSetting/index.vue').default
    },
    {
      path: 'customerArea',
      name: 'DcCosLbuCustomerArea',
      meta: { title: '客户区域管理' },
      component: require('@/views/yuntuSales/customerArea/index.vue').default
    },
    {
      path: 'employeeAreaSetting',
      name: 'DcCosLbuEmployeeAreaSetting',
      meta: { title: '员工区域设置' },
      component: require('@/views/yuntuSales/employeeAreaSetting/index.vue').default
    },
    {
      path: 'roadAreaCode',
      name: 'DcCosLbuRoadAreaCode',
      meta: { title: '员工路区代码' },
      component: require('@/views/yuntuSales/roadAreaCode/index.vue').default
    },
    {
      path: 'countryChannelSetting',
      name: 'DcCosLbuCountryChannelSetting',
      meta: { title: '国家渠道设置' },
      component: require('@/views/yuntuSales/operationsManage/countryChannelSetting/index.vue').default
    },
    {
      path: 'exportCenter/lbu',
      name: 'DcCosLbuExportCenter',
      meta: { title: '导出中心' },
      component: require('@/views/yuntuSales/exportCenter/index.vue').default
    },
    {
      path: 'dataReport',
      name: 'DcCosLbuDataReport',
      meta: {
        title: '数据简报',
        noCache: true
      },
      component: require('@/views/yuntuSales/marketLeads/dataReport/index.vue').default
    },
    {
      path: 'leadManage',
      name: 'DcCosLbuLeadManage',
      meta: { title: '市场线索管理' },
      component: require('@/views/yuntuSales/marketLeads/leadManage/index.vue').default
    },
    {
      path: 'leadManage/add',
      name: 'DcCosLbuLeadManageAdd',
      meta: { title: '新增市场线索' },
      component: require('@/views/yuntuSales/marketLeads/leadManage/add/index.vue').default
    },
    {
      path: 'leadManage/edit',
      name: 'DcCosLbuLeadManageEdit',
      meta: { title: '编辑市场线索' },
      component: require('@/views/yuntuSales/marketLeads/leadManage/edit/index.vue').default
    },
    {
      path: 'leadManage/view',
      name: 'DcCosLbuLeadManageView',
      meta: {
        title: '市场线索详情',
        noCache: true
      },
      component: require('@/views/yuntuSales/marketLeads/leadManage/view/index.vue').default
    },
    {
      path: 'deliveryRecord',
      name: 'DcCosLbuDeliveryRecord',
      meta: { title: '投放记录' },
      component: require('@/views/yuntuSales/marketLeads/deliveryRecord/index.vue').default
    },
    {
      path: 'tagsManage',
      name: 'DcCosLbuTagManage',
      meta: { title: '标签管理' },
      component: require('@/views/yuntuSales/marketing/tagManage/index.vue').default
    },
    {
      path: 'tagsManage/add',
      name: 'DcCosLbuTagManageAdd',
      meta: { title: '新增标签' },
      component: require('@/views/yuntuSales/marketing/tagManage/add.vue').default
    },
    {
      path: 'tagsManage/edit',
      name: 'DcCosLbuTagManageEdit',
      meta: { title: '编辑标签' },
      component: require('@/views/yuntuSales/marketing/tagManage/edit.vue').default
    },
    {
      path: 'tagsManage/view',
      name: 'DcCosLbuTagManageView',
      meta: {
        title: '标签详情',
        noCache: true
      },
      component: require('@/views/yuntuSales/marketing/tagManage/view.vue').default
    },
    {
      path: 'partnerManage',
      name: 'DcCosLbuPartnerManage',
      meta: { title: '合作伙伴管理' },
      component: require('@/views/yuntuSales/marketing/partnerManage/index.vue').default
    },
    {
      path: 'partnerManage/view',
      name: 'DcCosLbuPartnerManageView',
      meta: {
        title: '合作伙伴详情',
        noCache: true
      },
      component: require('@/views/yuntuSales/marketing/partnerManage/view/index.vue').default
    },
    {
      path: 'partnerManage/add',
      name: 'DcCosLbuPartnerManageAdd',
      meta: { title: '新增合作伙伴' },
      component: require('@/views/yuntuSales/marketing/partnerManage/add/index.vue').default
    },
    {
      path: 'partnerManage/edit',
      name: 'DcCosLbuPartnerManageEdit',
      meta: { title: '编辑合作伙伴' },
      component: require('@/views/yuntuSales/marketing/partnerManage/edit/index.vue').default
    },
    {
      path: 'activityCode',
      name: 'DcCosLbuActivityCode',
      meta: { title: '活码管理' },
      component: require('@/views/yuntuSales/marketing/activityCode/index.vue').default
    },
    {
      path: 'activityCode/add',
      name: 'DcCosLbuActivityCodeAdd',
      meta: { title: '新增活码' },
      component: require('@/views/yuntuSales/marketing/activityCode/add.vue').default
    },
    {
      path: 'activityCode/edit',
      name: 'DcCosLbuActivityCodeEdit',
      meta: { title: '编辑活码' },
      component: require('@/views/yuntuSales/marketing/activityCode/edit.vue').default
    },
    {
      path: 'activityCode/view',
      name: 'DcCosLbuActivityCodeView',
      meta: {
        title: '活码详情',
        noCache: true
      },
      component: require('@/views/yuntuSales/marketing/activityCode/view.vue').default
    },
    {
      path: 'templateManage',
      name: 'DcCosLbuTemplateManage',
      meta: { title: '模版管理' },
      component: require('@/views/yuntuSales/marketing/templateManage/index.vue').default
    },
    {
      path: 'cardManage',
      name: 'DcCosLbuCardManage',
      meta: { title: '名片管理' },
      component: require('@/views/yuntuSales/marketing/cardManage/index.vue').default
    },
    {
      path: 'interfaceRecord',
      name: 'DcCosLbuInterfaceRecord',
      meta: { title: '接口记录' },
      component: require('@/views/yuntuSales/marketing/interfaceRecord/index.vue').default
    },
    {
      path: 'registerLinksRecord',
      name: 'DcCosLbuRegisterLinksRecord',
      meta: { title: '注册链接发送记录' },
      component: require('@/views/yuntuSales/registerLinksRecord/index.vue').default
    },
    {
      path: 'marketingExport',
      name: 'DcCosLbuMarketingExport',
      meta: { title: '导出中心' },
      component: require('@/views/yuntuSales/exportCenter/index.vue').default
    },
    {
      path: 'visitToSign',
      name: 'DcCosLbuVisitToSign',
      meta: { title: '拜访签到' },
      component: require('@/views/yuntuSales/visitToSign/index.vue').default
    },
    {
      path: 'visitToSignDetail',
      name: 'DcCosLbuVisitToSignDetail',
      meta: { title: '拜访签到详情' },
      component: require('@/views/yuntuSales/visitToSign/detail.vue').default
    },
    {
      path: 'saleCoaching',
      name: 'DcCosLbuSaleCoaching',
      meta: { title: '销售业绩辅导' },
      component: require('@/views/yuntuSales/saleCoaching/index.vue').default
    },
    {
      path: 'saleCoaching/add',
      name: 'DcCosLbuSaleCoachingAdd',
      meta: { title: '新增销售业绩辅导' },
      component: require('@/views/yuntuSales/saleCoaching/add.vue').default
    },
    {
      path: 'saleCoaching/view',
      name: 'DcCosLbuSaleCoachingView',
      meta: { title: '销售业绩辅导详情' },
      component: require('@/views/yuntuSales/saleCoaching/view.vue').default
    },
    {
      path: 'saleCoaching/edit',
      name: 'DcCosLbuSaleCoachingEdit',
      meta: { title: '编辑销售业绩辅导' },
      component: require('@/views/yuntuSales/saleCoaching/edit.vue').default
    },
    {
      path: 'saleCoaching/review',
      name: 'DcCosLbuSaleCoachingReview',
      meta: { title: '回顾销售业绩辅导' },
      component: require('@/views/yuntuSales/saleCoaching/review.vue').default
    },
    {
      path: 'saleCoaching/comment',
      name: 'DcCosLbuSaleCoachingComment',
      meta: { title: '评论销售业绩辅导' },
      component: require('@/views/yuntuSales/saleCoaching/comment.vue').default
    },
    {
      path: 'supervisorAccompanyingVisit',
      name: 'DcCosLbuSupervisorAccompanyingVisit',
      meta: { title: '主管陪访（共同销售）' },
      component: require('@/views/yuntuSales/supervisorAccompanyingVisit/index.vue').default
    },
    {
      path: 'supervisorAccompanyingVisit/add',
      name: 'DcCosLbuSupervisorAccompanyingVisitAdd',
      meta: { title: '新增主管陪访（共同销售）' },
      component: require('@/views/yuntuSales/supervisorAccompanyingVisit/add.vue').default
    },
    {
      path: 'supervisorAccompanyingVisit/view',
      name: 'DcCosLbuSupervisorAccompanyingVisitDetail',
      meta: { title: '主管陪访（共同销售）详情' },
      component: require('@/views/yuntuSales/supervisorAccompanyingVisit/view.vue').default
    },
    {
      path: 'supervisorAccompanyingVisit/edit',
      name: 'DcCosLbuSupervisorAccompanyingVisitEdit',
      meta: { title: '编辑主管陪访（共同销售）' },
      component: require('@/views/yuntuSales/supervisorAccompanyingVisit/edit.vue').default
    },
    {
      path: 'supervisorAccompanyingVisit/comment',
      name: 'DcCosLbuSupervisorAccompanyingVisitComment',
      meta: { title: '评论主管陪访（共同销售）' },
      component: require('@/views/yuntuSales/supervisorAccompanyingVisit/comment.vue').default
    },
    {
      path: 'salesWorkReport/index',
      name: 'DcCosLbuSalesWorkReport',
      meta: { title: '销售工作情况表' },
      component: require('@/views/yuntuSales/salesWorkReport/index.vue').default
    },
    {
      path: 'labelManage',
      name: 'DcCosLbuLabelManage',
      meta: { title: '标签管理' },
      component: require('@/views/yuntuSales/labelManage/index.vue').default
    },
    {
      path: 'customerLabelManage',
      name: 'DcCosLbuCustomerLabelManage',
      meta: { title: '客户标签管理' },
      component: require('@/views/yuntuSales/customerLabelManage/index.vue').default
    },
    {
      path: 'chanceModifies',
      name: 'DcCosLbuChanceModifies',
      meta: { title: '商机变动情况' },
      component: require('@/views/yuntuSales/analysis/chanceModifies/index.vue').default
    },
    {
      path: 'salesCoachingReport',
      name: 'DcCosLbuSalesCoachingReport',
      meta: { title: '销售辅导情况表' },
      component: require('@/views/yuntuSales/analysis/salesCoachingReport/index.vue').default
    },
    {
      path: 'salesSkillsCoaching',
      name: 'DcCosLbuSalesSkillsCoaching',
      meta: { title: '销售技能辅导' },
      component: require('@/views/yuntuSales/salesSkillsCoaching/index.vue').default
    },
    {
      path: 'salesSkillsCoaching/add',
      name: 'DcCosLbuSalesSkillsCoachingAdd',
      meta: { title: '新增销售技能辅导' },
      component: require('@/views/yuntuSales/salesSkillsCoaching/add.vue').default
    },
    {
      path: 'salesSkillsCoaching/view',
      name: 'DcCosLbuSalesSkillsCoachingView',
      meta: { title: '销售技能辅导详情' },
      component: require('@/views/yuntuSales/salesSkillsCoaching/view.vue').default
    },
    {
      path: 'salesSkillsCoaching/edit',
      name: 'DcCosLbuSalesSkillsCoachingEdit',
      meta: { title: '编辑销售技能辅导' },
      component: require('@/views/yuntuSales/salesSkillsCoaching/edit.vue').default
    },
    {
      path: 'salesSkillsCoaching/review',
      name: 'DcCosLbuSalesSkillsCoachingReview',
      meta: { title: '回顾销售技能辅导' },
      component: require('@/views/yuntuSales/salesSkillsCoaching/review.vue').default
    },
    {
      path: 'salesSkillsCoaching/comment',
      name: 'DcCosLbuSalesSkillsCoachingComment',
      meta: { title: '评论销售技能辅导' },
      component: require('@/views/yuntuSales/salesSkillsCoaching/comment.vue').default
    },
    {
      path: 'couponsAudit',
      name: 'DcCosLbuCouponsAudit',
      meta: { title: '发券审核' },
      component: require('@/views/yuntuSales/couponsAudit/index.vue').default
    },
    {
      path: 'regionSetting',
      name: 'DcCosLbuRegionSetting',
      meta: { title: '区域员工设置' },
      component: require('@/views/yuntuSales/regionSetting/index.vue').default
    },
    {
      path: 'roadAreaConfig',
      name: 'DcCosLbuRoadAreaConfig',
      meta: { title: '员工路区设置' },
      component: require('@/views/yuntuSales/roadAreaConfig/index.vue').default
    },
    {
      path: 'roadAreaConfigReport',
      name: 'DcCosLbuRoadAreaConfigReport',
      meta: { title: 'NC客户信息' },
      component: require('@/views/yuntuSales/roadAreaConfigReport/index.vue').default
    },
    {
      path: 'zhiQuLog',
      name: 'DcCosLbuZhiQuLog',
      meta: { title: '数据推送日志' },
      component: require('@/views/yuntuSales/zhiQuLog/index.vue').default
    }
  ]
}

export default routerItem
